import { render, staticRenderFns } from "./UserPrivilegeTable.vue?vue&type=template&id=5f2977a6&scoped=true"
import script from "./UserPrivilegeTable.vue?vue&type=script&lang=js"
export * from "./UserPrivilegeTable.vue?vue&type=script&lang=js"
import style0 from "./UserPrivilegeTable.vue?vue&type=style&index=0&id=5f2977a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2977a6",
  null
  
)

export default component.exports